/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_Private_Chats_Enable_Confirm_OwnInputs */



/**
* | output |
* | --- |
* | "Each member will only see the chats they start, together with the files they attach and the documents the AI creates in them." |
*
* @param {Project_Private_Chats_Enable_Confirm_OwnInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const project_private_chats_enable_confirm_own = /** @type {((inputs?: Project_Private_Chats_Enable_Confirm_OwnInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Private_Chats_Enable_Confirm_OwnInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Jedes Mitglied sieht nur noch die Chats, die es selbst startet, samt den Dateien, die es darin anhängt, und den Dokumenten, die die KI darin erstellt.")
	return /** @type {LocalizedString} */ ("Each member will only see the chats they start, together with the files they attach and the documents the AI creates in them.")
});